import React, { RefObject } from 'react';
import { Popover } from '@milanote/roma';

type ChipSelectionPopoverProps = {
    triggerRef: RefObject<HTMLElement>;
    isOpen: boolean;
    onOpenChange: (isOpen: boolean) => void;
    children: React.ReactNode | ((close: () => void) => React.ReactNode);
};

const renderChildren = (children: ChipSelectionPopoverProps['children'], close: () => void) =>
    typeof children === 'function' ? children(close) : children;

/**
 * Renders a popover whose open state is driven by generic chip selection.
 */
const ChipSelectionPopover: React.FC<ChipSelectionPopoverProps> = ({ triggerRef, isOpen, onOpenChange, children }) => {
    const close = () => onOpenChange(false);

    return (
        <Popover triggerRef={triggerRef} isOpen={isOpen} onOpenChange={onOpenChange}>
            {renderChildren(children, close)}
        </Popover>
    );
};

export default ChipSelectionPopover;
